<template>
  <div>
    <top />

    <router-view></router-view>

    <bottom />
    <!-- <right /> -->
  </div>
</template>

<script>
import top from "@/views/basic/top.vue";
import bottom from "@/views/basic/bottom.vue";
import right from "@/views/basic/right.vue";
export default {
  components: {
    top,
    bottom,
    right,
  },
  //设置刷新浏览器  重新获取当前登录信息  2024/05/06 BY lixiaolong
  mounted() {
    if (localStorage.getItem("userJson") != {}) {
      var userinfo = JSON.parse(localStorage.getItem("userJson")) || {};
      this.$store.dispatch("setMessage", userinfo);
    }
    if (localStorage.getItem("favoriteJson") != {}) {
      var favoriute = JSON.parse(localStorage.getItem("favoriteJson")) || [];
      this.$store.dispatch("setFavoriteMessage", favoriute);
    }
    if (localStorage.getItem("xunjiaJson") != {}) {
      var xunjia = JSON.parse(localStorage.getItem("xunjiaJson")) || [];
      this.$store.dispatch("setxunjiaMessage", xunjia);
    }
    if (localStorage.getItem("bijiaoJson") != {}) {
      var bijiao = JSON.parse(localStorage.getItem("bijiaoJson")) || [];

      this.$store.dispatch("setbijiaoMessage", bijiao);
    }
    var Browser_Agent = navigator.userAgent;

    // 浏览器为IE的情况
    if (Browser_Agent.indexOf("MSIE") != -1) {
      var a = navigator.browserLanguage;
      if (a == "zh-cn") {
        //中文网站
        this.$i18n.locale = "zh";
      } else {
        // 英文网站
        this.$i18n.locale = "en";
      }
    }
    // 浏览器非IE的情况
    else {
      var b = navigator.language;
      if (b == "zh-CN") {
        // 中文网站
        this.$i18n.locale = "zh";
      } else {
        // 英文网站
        this.$i18n.locale = "en";
      }
    }
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped></style>
